import React from 'react';
import { Button } from '../../../Button';
import { MobileCalendarView, MobileCalendarViewProps } from '../../components/MobileCalendarView/MobileCalendarView.component';
import { AvailabilitySettings } from '../../AvailabilitySettings';
import { DayWithAvailabilityIndicator } from './Day.component';


export const Calendar: React.FC<MobileCalendarViewProps> = (props) => {
  const headerLeftAddons = React.useCallback(({ goToToday }: { goToToday: () => void }) => {
    return (
      <Button
        size="small"
        variant="outlined"
        onClick={goToToday}
      >
        Today
      </Button>
    );
  }, []);

  const headerRightAddons = React.useCallback(() => {
    return (
      <AvailabilitySettings />
    );
  }, []);

  return (
    <MobileCalendarView
      {...props}
      headerLeftAddons={headerLeftAddons}
      headerRightAddons={headerRightAddons}
      components={{
        Day: DayWithAvailabilityIndicator,
      }}
    />
  );
};
